import React from "react";

function EngBtn() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="60"
      height="40"
      fill="none"
      viewBox="0 0 60 40"
    >
      <g filter="url(#filter0_b_4062_177)">
        <rect
          width="59"
          height="39"
          x="0.5"
          y="0.51"
          stroke="#000"
          rx="12.5"
        ></rect>
        <path
          fill="#000"
          d="M21.037 25.203c-.62 0-1.174-.102-1.664-.305a3.664 3.664 0 01-1.232-.88 4.108 4.108 0 01-.768-1.376 5.745 5.745 0 01-.272-1.823c0-.662.085-1.26.256-1.793a3.93 3.93 0 01.768-1.36c.33-.384.736-.677 1.216-.88.48-.213 1.024-.32 1.632-.32.65 0 1.216.112 1.696.336.48.224.874.529 1.184.913.309.384.538.832.688 1.343.16.502.24 1.04.24 1.616v.672h-5.552v.209c0 .608.17 1.098.512 1.471.34.363.848.544 1.52.544.512 0 .928-.106 1.248-.32.33-.213.624-.485.88-.816l1.104 1.232c-.342.48-.811.86-1.408 1.136-.587.267-1.27.4-2.048.4zm-.032-7.2c-.544 0-.976.18-1.296.544-.32.362-.48.831-.48 1.407v.128h3.424v-.143c0-.576-.144-1.04-.432-1.392-.278-.363-.683-.544-1.216-.544zm5.577 7.008v-8.352h2.048v1.392h.08c.171-.448.438-.822.8-1.12.374-.31.886-.465 1.536-.465.864 0 1.526.283 1.984.848.46.566.688 1.371.688 2.416v5.28H31.67v-5.072c0-.597-.106-1.045-.32-1.343-.213-.3-.565-.448-1.056-.448a2.06 2.06 0 00-.624.096 1.618 1.618 0 00-.528.256c-.149.106-.272.245-.368.416a1.1 1.1 0 00-.144.576v5.52h-2.048zm16.943.704c0 .437-.08.82-.24 1.151-.15.342-.4.625-.752.849-.352.224-.806.394-1.36.512-.555.117-1.232.175-2.032.175-.704 0-1.302-.047-1.792-.143-.491-.086-.896-.214-1.216-.384-.31-.16-.534-.363-.672-.608a1.66 1.66 0 01-.208-.832c0-.47.128-.838.384-1.104.266-.256.634-.422 1.104-.497v-.175a1.415 1.415 0 01-.8-.496 1.51 1.51 0 01-.272-.896c0-.214.042-.4.128-.56.085-.171.197-.315.336-.433.149-.117.314-.213.496-.288.181-.085.373-.149.576-.192v-.064c-.512-.234-.896-.56-1.152-.976-.246-.416-.368-.9-.368-1.456 0-.853.293-1.535.88-2.047.586-.523 1.445-.785 2.576-.785.256 0 .506.017.752.049.256.032.49.085.704.16v-.273c0-.81.394-1.216 1.184-1.216h1.296v1.569H41.3v.224c.437.245.762.565.976.96.213.394.32.848.32 1.36 0 .842-.294 1.52-.88 2.032-.576.512-1.435.768-2.576.768-.491 0-.918-.049-1.28-.145a1.31 1.31 0 00-.416.305.607.607 0 00-.176.447c0 .416.362.625 1.088.625h2.24c1.024 0 1.765.213 2.224.64.469.416.704.997.704 1.744zm-1.92.24a.72.72 0 00-.32-.624c-.214-.15-.582-.224-1.104-.224h-2.848a1.02 1.02 0 00-.432.864c0 .32.133.57.4.752.266.18.72.271 1.36.271h1.024c.672 0 1.157-.085 1.456-.256a.839.839 0 00.464-.784zm-2.464-5.248c1.002 0 1.504-.427 1.504-1.28v-.273c0-.853-.502-1.28-1.504-1.28-1.003 0-1.504.427-1.504 1.28v.273c0 .853.501 1.28 1.504 1.28z"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_b_4062_177"
          width="145.515"
          height="125.515"
          x="-42.757"
          y="-42.747"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feGaussianBlur
            in="BackgroundImageFix"
            stdDeviation="21.379"
          ></feGaussianBlur>
          <feComposite
            in2="SourceAlpha"
            operator="in"
            result="effect1_backgroundBlur_4062_177"
          ></feComposite>
          <feBlend
            in="SourceGraphic"
            in2="effect1_backgroundBlur_4062_177"
            result="shape"
          ></feBlend>
        </filter>
      </defs>
    </svg>
  );
}

export default EngBtn;